import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {AppLogger, AppLoggerService} from "../../core/logging";

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  standalone: false
})
export class LandingComponent implements OnInit {

  readonly log: AppLogger;

  redirectUri?: string;

  constructor(
    private route: ActivatedRoute,
    private appLogger: AppLoggerService
  ) {
    this.log = this.appLogger.createForClass(LandingComponent);
  }

  ngOnInit(): void {
    const qp = this.route.snapshot.queryParamMap;
    const redirectUri = qp.get('redirectUri') ?? '/home';
    this.redirectUri = redirectUri.startsWith('/') ? redirectUri : '/home';
    this.log.info(`Login Process: redirectUri=${this.redirectUri}`);
  }

}
